// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4747":"e818508b","7409":"d097d76f"}[chunkId] + ".chunk.css";
};